import React from 'react';
import theme from '../../../styles/theme';

const PreownedHomes = () => (
  <svg
    width={60}
    height={61}
    viewBox='0 0 60 61'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M39.3586 25.242C42.0096 25.242 44.1586 23.093 44.1586 20.442C44.1586 17.791 42.0096 15.642 39.3586 15.642C36.7076 15.642 34.5586 17.791 34.5586 20.442C34.5586 23.093 36.7076 25.242 39.3586 25.242Z'
      fill='white'
    />
    <path
      d='M40.0202 20.562C36.5402 17.082 36.5402 11.502 40.0202 8.02199C43.5002 4.54199 49.0802 4.54199 52.5602 8.02199C56.0402 11.502 56.0402 17.082 52.5602 20.562C49.0802 24.042 43.4402 24.042 40.0202 20.562ZM49.9802 10.602C47.9402 8.56199 44.5802 8.56199 42.5402 10.602C40.5002 12.642 40.5002 16.002 42.5402 18.042C44.5802 20.082 47.9402 20.082 49.9802 18.042C52.0202 16.002 52.0202 12.642 49.9802 10.602Z'
      fill='#97D700'
    />
    <path
      d='M35.2313 24.5691L35.2369 24.5747L35.2426 24.5802C37.5442 26.8098 41.1689 26.8257 43.4255 24.5691C45.6761 22.3186 45.6761 18.6254 43.4255 16.3749C41.175 14.1244 37.4819 14.1244 35.2313 16.3749C32.9808 18.6254 32.9808 22.3186 35.2313 24.5691ZM49.2688 28.3775L24.5984 53.0478L6.81265 35.262L31.483 10.5917L46.7676 13.0928L49.2688 28.3775Z'
      fill='#DFF3B2'
      stroke='black'
      strokeWidth={2}
    />
    <path
      d='M48.7186 18.942C47.2186 19.722 45.4186 19.722 43.9186 19.002C44.2786 20.202 44.1586 21.582 43.5586 22.722C45.4186 23.322 47.4586 23.262 49.3186 22.602L48.7186 18.942Z'
      fill='#97D700'
    />
  </svg>
);

export default PreownedHomes;
